/** @file The share of a step that one pixel of a fine (shift) scrub moves. */

/** A fine scrub moves a tenth of a step per pixel. */
export const fineFactor = 0.1;
